import { Box, Typography } from '@mui/material';
import vaultArrow from '../../assets/vaultArrow.svg';

interface VaultBoxProps {
  name: string;
  icon?: string;
  onClick?: () => void;
  href?: string;
}

export default function VaultBox({ name, icon, onClick, href }: VaultBoxProps) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        padding: '1rem 0 1rem 1.25rem',
        gap: '0.625rem',
        width: '100%',
        maxWidth: '23.2rem',
        minWidth: '19.2rem',
        minHeight: '4.75rem',
        background: 'rgba(255, 255, 255, 0.06)',
        borderRadius: '1.5625rem',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          background: 'rgba(255, 255, 255, 0.1)'
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.625rem',
          flex: 1
        }}
      >
        {/* Icon Container */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '2.125rem',
            height: '2.125rem'
          }}
        >
          {icon && (
            <img
              src={icon}
              alt={`${name} icon`}
              style={{
                width: '2.125rem',
                height: '2.125rem'
              }}
            />
          )}
        </Box>

        {/* Text */}
        <Typography
          sx={{
            fontFamily: 'Outfit',
            fontWeight: 500,
            fontSize: '1.5rem',
            lineHeight: '1.0625rem',
            color: '#FFFFFF',
            flex: 1
          }}
        >
          {name}
        </Typography>

        {/* Arrow Icon */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '0.4375rem',
            width: '2.125rem',
            height: '2.125rem',
            marginRight: '0.625rem'
          }}
        >
          <img src={vaultArrow} alt="vault arrow" />
        </Box>
      </Box>
    </Box>
  );
}
